const recipesList = [
  {
    id: 1,
    title: "The Best Homemade BBQ Chicken Pizza",
    introduction:
      "Are you tired of eating the same boxed frozen pizza? I thought so, that's why in this recipe I'm going to show you how to make the best homemade BBQ Chicken Pizza.",
    ingredientSets: [
      {
        ingredientSetTitle: "Pizza Dough Ingredients",
        ingredients: [
          {
            quantity: "400g or 2 cups",
            ingredient: `"00" flour`,
          },
          {
            quantity: "10g or 2 tsp",
            ingredient: "honey",
          },
          {
            quantity: "10g or 2 tsp",
            ingredient: "salt",
          },
          {
            quantity: "245 or 1¼  cups",
            ingredient: "warm water",
          },
          {
            quantity: "1g or ¼ tsp",
            ingredient: "yeast",
          },
          {
            quantity: "15g or 1 tbsp",
            ingredient: "olive oil",
          },
        ],
      },
      {
        ingredientSetTitle: "BBQ Sauce Ingredients",
        ingredients: [
          {
            quantity: "15g or 1 tbsp",
            ingredient: "cornstarch/water",
          },
          {
            quantity: "15g or 1 tbsp",
            ingredient: "olive oil",
          },
          {
            quantity: "½ medium",
            ingredient: "sliced onion",
          },
          {
            quantity: "2 cloves",
            ingredient: "sliced garlic",
          },
          {
            quantity: "2 12fl oz cans",
            ingredient: "coca cola",
          },
          {
            quantity: "255g or 1 cup",
            ingredient: "diced tomatoes",
          },
          {
            quantity: "35g or 2 tbsp",
            ingredient: "tomato paste",
          },
          {
            quantity: "41g or 2 tbsp",
            ingredient: "molasses",
          },
          {
            quantity: "41g or 3 tbsp",
            ingredient: "apple cider vinegar",
          },
          {
            quantity: "29g or ¼ cup",
            ingredient: "brown sugar",
          },
          {
            quantity: "2.5g or ½ tsp",
            ingredient: "smoked paprika",
          },
          {
            quantity: "2.5g or ½ tsp",
            ingredient: "mustard powder",
          },
          {
            quantity: "58g or ¼",
            ingredient: "worcestershire sauce ",
          },
        ],
      },
      {
        ingredientSetTitle: "Pizza Ingredients",
        ingredients: [
          {
            quantity: "",
            ingredient: "Pizza dough",
          },
          {
            quantity: "",
            ingredient: "BBQ sauce",
          },
          {
            quantity: "",
            ingredient: "Sliced red onion",
          },
          {
            quantity: "",
            ingredient: "Chicken breast (seared)",
          },
          {
            quantity: "",
            ingredient: "Cilantro",
          },
          {
            quantity: "",
            ingredient: "Low moisture mozzarella",
          },
        ],
      },
    ],
    methods: [
      {
        methodName: "Dough",
        yield: "2 large pizza dough",
        process: [
          {
            step: 1,
            stepDescription: `In a bowl mix "00" flour with salt.`,
          },
          {
            step: 2,
            stepDescription:
              "In a separate bowl mix honey, yeast, and olive oil into the warm water (100F or 38C)",
          },
          {
            step: 3,
            stepDescription:
              "Combine wet mix into dry and mix with your hand until forms a shaggy dough",
          },
          {
            step: 4,
            stepDescription:
              "Place the dough onto the table and knead for 8-10min or until the surface of the dough is smooth and not sticky.",
          },
          {
            step: 5,
            stepDescription:
              "Form the dough into a ball and place it into a oiled bowl and cover it to proof for 2 hours in room temp",
          },
          {
            step: 6,
            stepDescription:
              "Divide the dough and form into a ball, place it on a oiled plate, cover it and place the dough in a the fridge to cold ferment for at least 16-24hrs",
          },
        ],
      },
      {
        methodName: "BBQ Sauce",
        yield: "2 Cups",
        process: [
          {
            step: 1,
            stepDescription:
              "Heat pot with olive oil and saute onion until soft, then add garlic and cook for an additional 1 min.",
          },
          {
            step: 2,
            stepDescription:
              "Add in tomatoes and tomato paste and cook until the liquid from the tomatoes are evaporated",
          },
          {
            step: 3,
            stepDescription:
              "Add in rest of the ingredients and reduce down by half(2 Cups) est.30min",
          },
          {
            step: 4,
            stepDescription: "Blend in a blender until smooth",
          },
        ],
      },
      {
        methodName: "BBQ Pizza",
        yield: "",
        process: [
          {
            step: 1,
            stepDescription:
              "Cover your dough in flour and place it onto your work surface",
          },
          {
            step: 2,
            stepDescription:
              "Press the middle of the dough leaving about an inch on the outer rim for the crust.",
          },
          {
            step: 3,
            stepDescription:
              "Gently stretch out the dough until you reach your desired size for your pizza ",
          },
          {
            step: 4,
            stepDescription: "Place your pizza dough onto a floured peele",
          },
          {
            step: 5,
            stepDescription:
              "Assemble the pizza, then slide your pizza onto your pizza stone in your oven that's been preheated to 525F (274C) ",
          },
          {
            step: 6,
            stepDescription:
              "Bake for about 8 min or until your pizza has a nice golden brown crust.",
          },
        ],
      },
    ],
    imageLink: "/images/pizza.jpg",
    youtubeLink: "https://www.youtube.com/watch?v=hk_SMj10Bco",
  },
  {
    id: 2,
    title: "The Perfect Beef Wellington For Your Date Night Dinner",
    introduction:
      "Beef Wellington is easily one of the best shareable dishes to make during the holidays for your friends and family. However, with this method, you can make it for the perfect date night dinner to impress your significant other.",
    ingredientSets: [
      {
        ingredientSetTitle: "Duxelle",
        ingredients: [
          {
            quantity: "2-3 Cups",
            ingredient:
              "Finely chopped mushrooms (mix of any mushrooms of your choice)",
          },
          {
            quantity: "1",
            ingredient: "Shallot (minced)",
          },
          {
            quantity: "1",
            ingredient: "Garlic (minced)",
          },
          {
            quantity: "2",
            ingredient: "Sprigs of thyme (leaves)",
          },
          {
            quantity: "",
            ingredient: "Fine sea salt",
          },
        ],
      },
      {
        ingredientSetTitle: "Red Wine Sauce",
        ingredients: [
          {
            quantity: "300ml",
            ingredient: "Red wine",
          },
          {
            quantity: "1",
            ingredient: "Shallot (minced)",
          },
          {
            quantity: "1",
            ingredient: "Garlic (minced)",
          },
          {
            quantity: "1",
            ingredient: "Sprig of thyme (leaves)",
          },
          {
            quantity: "1 tbsp",
            ingredient: "Unsalted butter",
          },
        ],
      },
      {
        ingredientSetTitle: "Beef Wellington",
        ingredients: [
          {
            quantity: "",
            ingredient: "Tenderloin steak (Filet mignon)",
          },
          {
            quantity: "",
            ingredient: "Prosciutto",
          },
          {
            quantity: "",
            ingredient: "Puff Pastry",
          },
          {
            quantity: "",
            ingredient: "Duxelle",
          },
          {
            quantity: "",
            ingredient: "Egg Wash",
          },
          {
            quantity: "",
            ingredient: "Flakey salt",
          },
          {
            quantity: "",
            ingredient: "Dijon Mustard",
          },
        ],
      },
    ],
    methods: [
      {
        methodName: "Duxelle (Mushroom Filling)",
        yield: "2 Cups",
        process: [
          {
            step: 1,
            stepDescription:
              "Finely chop mix of mushrooms (You can also use the food processor)",
          },
          {
            step: 2,
            stepDescription:
              "Heat a nonstick pan over medium heat, add in your minced shallot, garlic, mushroom mix, thyme leaves and salt to sweat down.",
          },
          {
            step: 3,
            stepDescription:
              "Cook your mushroom mix down until most of the moisture is cooked out. (About 8-10min)",
          },
          {
            step: 4,
            stepDescription:
              "Lay out the mushroom mix to cool down and set aside.",
          },
        ],
      },
      {
        methodName: "Red Wine Sauce",
        yield: "",
        process: [
          {
            step: 1,
            stepDescription:
              "Combine red wine, shallot, garlic, thyme leaves into a small pot and bring up to a simmer to reduce.",
          },
          {
            step: 2,
            stepDescription:
              "Once the red wine gets thick add in your butter and stir until the butter is fully incorporated. ",
          },
        ],
      },
      {
        methodName: "Beef Wellington ",
        yield: "",
        process: [
          {
            step: 1,
            stepDescription:
              "Tie your tenderloin steak with a butcher's twine.",
          },
          {
            step: 2,
            stepDescription:
              "Season with salt and pepper, then sear your tenderloin steak on high heat. (Make sure not to leave it in the pan for too long, you just want some color on the steak without cooking it.)",
          },
          {
            step: 3,
            stepDescription:
              "Place your steak onto a plate and cut the butcher's twine off.",
          },
          {
            step: 4,
            stepDescription:
              "Lightly brush your steak with dijon mustard and set aside to rest.",
          },
          {
            step: 5,
            stepDescription:
              "Lay out a sheet of plastic then lay out your prosciutto on top of the plastic ( make sure your prosciutto is slightly overlapping each other.)",
          },
          {
            step: 6,
            stepDescription:
              "Spread just enough duxelle to cover bottom surface of the steak and place your steak on top of the duxelle",
          },
          {
            step: 7,
            stepDescription:
              "Tightly wrap the steak by folding over the plastic wrap that's underneath, and twist the plastic wrap to form a tight ball then place in your fridge for about 5-10 min to firm up.",
          },
          {
            step: 8,
            stepDescription:
              "Lightly roll out your puff pastry (about 16th of a inch) on a lightly floured work surface.",
          },
          {
            step: 9,
            stepDescription:
              "Place your prosciutto wrapped steak onto your puff pastry, and lightly brush around the steak with egg wash then cover it with another puff pastry. Press the edges firmly to close off the puff pastry.",
          },
          {
            step: 10,
            stepDescription:
              "Brush your wellington with egg wash and sprinkle some flakey salt, then cut out your wellington to remove any excess puff pastry. (optionally you can add a lattice design with another puff pastry using a lattice roller.)",
          },
          {
            step: 11,
            stepDescription:
              "Bake in an oven that's been preheated to 425F(218C) until your puff pastry is golden brown. (adjust cooking time to desired temperature of the steak, About 8min for medium rare)",
          },
        ],
      },
    ],
    imageLink: "/images/wellington.jpg",
    youtubeLink: "https://www.youtube.com/watch?v=bgiErjMrp5Q&t=39s",
  },
  {
    id: 3,
    title: "The Ultimate Souffle Pancake",
    introduction:
      "Everyone loves a fluffy pancake, but if you want to take your fluffy pancake game to the next level we need to explore the realm of the Japanese souffle pancake, So in this recipe, I'll show you the secrets to making this pancake masterpiece!",
    ingredientSets: [
      {
        ingredientSetTitle: "Souffle Pancake",
        ingredients: [
          {
            quantity: "2",
            ingredient: "Egg Yolks",
          },
          {
            quantity: "2 Tbps",
            ingredient: "Whole Milk",
          },
          {
            quantity: "2 Tsp",
            ingredient: "Vanilla Extract",
          },
          {
            quantity: "⅓ Cup",
            ingredient: "Cake Flour",
          },
          {
            quantity: "3",
            ingredient: "Egg Whites",
          },
          {
            quantity: "1 Tsp",
            ingredient: "White Vinegar",
          },
          {
            quantity: "¼ Cup",
            ingredient: "Granulated sugar",
          },
        ],
      },
      {
        ingredientSetTitle: "Matcha Anglaise",
        ingredients: [
          {
            quantity: "½ Cup",
            ingredient: "Whole Milk",
          },
          {
            quantity: "½ Cup",
            ingredient: "Heavy Whipping Cream",
          },
          {
            quantity: "1 Tbsp",
            ingredient: "Matcha Powder",
          },
          {
            quantity: "1 Tsp",
            ingredient: "Vanilla Extract",
          },
          {
            quantity: "¼ Cup",
            ingredient: "Granulated Sugar",
          },
        ],
      },
      {
        ingredientSetTitle: "Crumble",
        ingredients: [
          {
            quantity: "¼ Cup",
            ingredient: "All-Purpose Flour",
          },
          {
            quantity: "2 Tbsp",
            ingredient: "Unsalted Butter",
          },
          {
            quantity: "1 Tbsp",
            ingredient: "Granulated Sugar",
          },
          {
            quantity: "1 Tbsp",
            ingredient: "Brown Sugar",
          },
          {
            quantity: "¼ Cup",
            ingredient: "Coconut Flakes",
          },
        ],
      },
    ],
    methods: [
      {
        methodName: "Souffle Pancake",
        yield: "4-6",
        process: [
          {
            step: 1,
            stepDescription:
              "Combine egg yolks, milk, vanilla extract into a mixing bowl and mix thoroughly with a whisk.",
          },
          {
            step: 2,
            stepDescription:
              "Sift in the cake flour into your bowl and mix into a smooth batter, then set aside.",
          },
          {
            step: 3,
            stepDescription:
              "Combine egg whites and white vinegar into a stand mixer bowl, then start the mixer with a whisk attachment on low speed.",
          },
          {
            step: 4,
            stepDescription:
              "Once you see big bubbles form, increase the speed and whip until your meringue reaches a soft peak.",
          },
          {
            step: 5,
            stepDescription:
              "Now on high speed, gradually add in your sugar and whip until your meringue reaches a stiff peak. (make sure you dont over whip it)",
          },
          {
            step: 6,
            stepDescription: "Fold in the meringue into the batter.",
          },
          {
            step: 7,
            stepDescription:
              "Heat a non-stick pan that's been lightly coated with vegetable oil on low heat and pipe two tall mounds of your pancake batter, then add a few drops of water and cover to cook for about 3 min.",
          },
          {
            step: 8,
            stepDescription: "Carefully flip the pancake and repeat.",
          },
        ],
      },
      {
        methodName: "Matcha Anglaise",
        yield: "2 Cups",
        process: [
          {
            step: 1,
            stepDescription:
              "Combine milk, heavy whipping cream, vanilla extract, matcha powder into a small sauce pot and bring it up to just below simmering on low heat.",
          },
          {
            step: 2,
            stepDescription:
              "In a separate bowl combine egg yolk and sugar and whisk until you reach a pale yellow.",
          },
          {
            step: 3,
            stepDescription:
              "Pour some of the warm cream mixture into the egg mixture to slowly bring up the temperature and pour the mixture back into the pot to avoid scrambling the egg.",
          },
          {
            step: 4,
            stepDescription:
              "Heat the mixture on low heat, stirring frequently until the mixture is thick enough to coat the back of a spoon.",
          },
        ],
      },
      {
        methodName: "Coconut Flake Crumble",
        yield: "½ Cup",
        process: [
          {
            step: 1,
            stepDescription:
              "Mix unsalted butter, flour, sugar, brown sugar, and coconut flakes into a bowl.",
          },
          {
            step: 2,
            stepDescription:
              "Mix thoroughly by using your hands, make sure to break up the butter to end up with a crumble texture.",
          },
          {
            step: 3,
            stepDescription:
              "Spread your crumble onto a baking tray with a parchment paper and bake at 350F (176C) for about 8-9 min until golden brown.",
          },
        ],
      },
    ],
    imageLink: "/images/souffle.jpg",
    youtubeLink: "https://www.youtube.com/watch?v=bLHmkTjnRec&t=20s",
  },
  {
    id: 4,
    title: "Homemade English Muffins 2 Ways",
    introduction:
      "English muffin is something you usually go to the grocery store to buy, but you can make this in your home without any special kitchen equipment and using everyday ingredients that you probably already have. This recipe isn't difficult to make but you will be dealing with sticky dough so I'm also going to show you another method of making this recipe with some special kitchen equipment to make the whole process easier!",
    ingredientSets: [
      {
        ingredientSetTitle: "English Muffin",
        ingredients: [
          {
            ingredient: "bread flour",
            quantity: "2 Cups (285g)",
          },
          {
            ingredient: "instant dry yeast",
            quantity: "1 Tsp (3g)",
          },
          {
            ingredient: "sugar",
            quantity: "1 Tbs (12g)",
          },
          {
            ingredient: "whole milk, lukewarm",
            quantity: "1 cup (200g)",
          },
          {
            ingredient: "unsalted butter, soft/melted",
            quantity: "½ Tbs (21g)",
          },
          {
            ingredient: "kosher salt",
            quantity: "½ Tsp (3g)",
          },
          {
            ingredient: "whole egg, lightly whipped",
            quantity: "1",
          },
          {
            ingredient: "Cornmeal, for dusting",
            quantity: "",
          },
        ],
      },
    ],
    methods: [
      {
        methodName: "With Special Kitchen Equipment (Stand Mixer)",
        yield: "6-7",
        process: [
          {
            step: 1,
            stepDescription:
              "Combine bread flour, instant dry yeast, sugar in the bowl of a stand mixer with a whisk.",
          },
          {
            step: 2,
            stepDescription:
              "Add in your lukewarm milk, unsalted butter (soft/melted), kosher salt, egg (lightly whipped)",
          },
          {
            step: 3,
            stepDescription:
              "Attach your stand mixer bowl to your stand mixer with the dough hook attachment and mix on the lowest speed until your mixture forms into a shaggy dough.",
          },
          {
            step: 4,
            stepDescription:
              "You can increase the speed on your stand mixer by one notch and let your stand mixer knead the dough until it starts to pull away from the sides of your bowl (About 5-8min)",
          },
          {
            step: 5,
            stepDescription:
              "Transfer your dough into a separate bowl that has been lightly oiled and cover it with plastic wrap to rise for about 2 hours (at room temperature)",
          },
          {
            step: 6,
            stepDescription:
              "Place your dough onto a floured work surface and lightly dust your dough with flour, then take a rolling pin and roll your dough out to about ½ inch in thickness.",
          },
          {
            step: 7,
            stepDescription:
              "Using a medium-sized round cookie cutter, cut out your English muffins. Bring your dough back together and roll them back out to cut more out.",
          },
          {
            step: 8,
            stepDescription:
              "Place your English muffins onto a baking tray with parchment paper that has been lightly dusted with cornmeal.",
          },
          {
            step: 9,
            stepDescription:
              "Cover your baking tray with plastic wrap and let them rise again (about 30min~1hour)",
          },
          {
            step: 10,
            stepDescription:
              "Heat a non-stick pan or a cast iron pan over medium heat with a light coating of oil.",
          },
          {
            step: 11,
            stepDescription:
              "Gently place your English muffins onto your pan and cook until you get a nice golden brown color, then do the same to the other side.",
          },
          {
            step: 12,
            stepDescription:
              "Place your English muffins back onto your sheet tray and bake in an oven that’s been preheated to 350F(176C) for about 5~8min.",
          },
        ],
      },
      {
        methodName: "Without Special Kitchen Equipment",
        yield: "6-7",
        process: [
          {
            step: 1,
            stepDescription:
              "Combine bread flour, instant dry yeast, sugar in a bowl with a whisk.",
          },
          {
            step: 2,
            stepDescription:
              "Add in your lukewarm milk, unsalted butter (soft/melted), kosher salt, egg (lightly whipped)",
          },
          {
            step: 3,
            stepDescription:
              "Mix with your hand until the mixture forms into a shaggy dough then place your dough onto a floured work surface.",
          },
          {
            step: 4,
            stepDescription:
              "Pick up the dough and fold it as soon as you slap it onto your table, repeat this until your dough stops sticking to your table (about 15min)",
          },
          {
            step: 5,
            stepDescription:
              "Transfer your dough into a bowl that has been lightly oiled and cover it with plastic wrap to rise for about 2 hours (at room temperature)",
          },
          {
            step: 6,
            stepDescription:
              "Place your dough onto a floured work surface and lightly dust your dough with flour, then divide your dough into 6 or 7 even pieces.",
          },
          {
            step: 7,
            stepDescription:
              "Roll your dough into a ball and place your dough balls onto a baking tray with parchment paper that has been lightly dusted with cornmeal.",
          },
          {
            step: 8,
            stepDescription:
              "Cover your baking tray with plastic wrap and let them rise again (about 30min~1hour)",
          },
          {
            step: 9,
            stepDescription:
              "Heat a non-stick pan or a cast iron pan over medium heat with a light coating of oil.",
          },
          {
            step: 10,
            stepDescription:
              "Gently place your English muffins onto your pan and cook until you get a nice golden brown color, then do the same to the other side.",
          },
          {
            step: 11,
            stepDescription:
              "Place your English muffins back onto your sheet tray and bake in an oven that's been preheated to 350F(176C) for about 5~8min.",
          },
        ],
      },
    ],
    imageLink: "/images/muffins.jpg",
    youtubeLink: "https://www.youtube.com/watch?v=O7H64bLINAs&t=65s",
  },
];

export default recipesList;
